import { jsPDF } from 'jspdf';

const NAVY = [16, 45, 85];
const SLATE = [71, 85, 105];

const F = (job) => ({
  id: job.id,
  service: job.service_name || job.service || '',
  category: job.pillar_name || '',
  property: job.property_address || job.address || '',
  size: job.property_size || job.size || '',
  date: job.scheduled_date || job.date || '',
  inspector: job.assigned_contractor_name || job.contractor || 'Unassigned',
  client: job.client_org || job.client || '',
  summary: job.summary || '',
  price: job.price,
});

const header = (doc, title) => {
  doc.setFillColor(...NAVY); doc.rect(0, 0, 210, 30, 'F');
  doc.setTextColor(255, 255, 255); doc.setFont('helvetica', 'bold'); doc.setFontSize(18);
  doc.text('Check-a-Property', 14, 14);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(10);
  doc.text('Property inventory, safety & maintenance reporting', 14, 22);
  doc.setTextColor(...NAVY); doc.setFont('helvetica', 'bold'); doc.setFontSize(16);
  doc.text(title, 14, 44);
};

const kv = (doc, label, value, y) => {
  doc.setFont('helvetica', 'bold'); doc.setTextColor(...SLATE); doc.setFontSize(10);
  doc.text(label, 14, y);
  doc.setFont('helvetica', 'normal'); doc.setTextColor(20, 20, 20);
  doc.text(String(value), 70, y);
};

export const generateReportPDF = (job) => {
  const j = F(job); const doc = new jsPDF();
  header(doc, 'Inspection Report');
  let y = 56;
  kv(doc, 'Report ref', j.id, y); y += 8;
  kv(doc, 'Service', j.service, y); y += 8;
  kv(doc, 'Category', j.category, y); y += 8;
  kv(doc, 'Property', j.property, y); y += 8;
  kv(doc, 'Property size', j.size, y); y += 8;
  kv(doc, 'Inspection date', j.date, y); y += 8;
  kv(doc, 'Inspector', j.inspector, y); y += 8;
  kv(doc, 'Client', j.client, y); y += 12;
  doc.setFont('helvetica', 'bold'); doc.setTextColor(...NAVY); doc.setFontSize(12);
  doc.text('Summary of findings', 14, y); y += 8;
  doc.setFont('helvetica', 'normal'); doc.setTextColor(30, 30, 30); doc.setFontSize(10);
  const lines = doc.splitTextToSize(j.summary || 'No summary recorded for this job.', 182);
  doc.text(lines, 14, y); y += lines.length * 6 + 8;

  // Structured inventory rooms
  const rooms = Array.isArray(job.inventory) ? job.inventory : [];
  rooms.forEach((room) => {
    if (y > 250) { doc.addPage(); y = 20; }
    doc.setFont('helvetica', 'bold'); doc.setTextColor(...NAVY); doc.setFontSize(12);
    doc.text(room.name, 14, y); y += 6;
    doc.setDrawColor(220, 224, 230); doc.line(14, y, 196, y); y += 6;
    (room.items || []).forEach((it) => {
      if (y > 270) { doc.addPage(); y = 20; }
      doc.setFont('helvetica', 'bold'); doc.setTextColor(30, 30, 30); doc.setFontSize(10);
      doc.text(`${it.name}${it.condition ? '  [' + it.condition + ']' : ''}`, 16, y); y += 5;
      const detail = [it.description, it.notes].filter(Boolean).join(' — ');
      if (detail) { doc.setFont('helvetica', 'normal'); doc.setTextColor(80, 80, 80);
        const dl = doc.splitTextToSize(detail, 176); doc.text(dl, 20, y); y += dl.length * 5; }
      y += 2;
    });
    y += 4;
  });

  if (y > 270) { doc.addPage(); y = 20; }
  doc.setDrawColor(220, 224, 230); doc.line(14, y, 196, y); y += 8;
  doc.setFontSize(9); doc.setTextColor(...SLATE);
  doc.text('Sample report generated by Check-a-Property for demonstration purposes.', 14, y);
  doc.save(`${j.id}-report.pdf`);
};

export const generateInvoicePDF = (job) => {
  const j = F(job); const doc = new jsPDF();
  header(doc, 'Invoice');
  let y = 56;
  kv(doc, 'Invoice ref', 'INV-' + j.id, y); y += 8;
  kv(doc, 'Job ref', j.id, y); y += 8;
  kv(doc, 'Billed to', j.client, y); y += 8;
  kv(doc, 'Property', j.property, y); y += 8;
  kv(doc, 'Date', j.date, y); y += 14;
  doc.setFillColor(241, 245, 249); doc.rect(14, y, 182, 10, 'F');
  doc.setFont('helvetica', 'bold'); doc.setTextColor(...SLATE); doc.setFontSize(10);
  doc.text('Description', 18, y + 7); doc.text('Amount', 170, y + 7); y += 18;
  doc.setFont('helvetica', 'normal'); doc.setTextColor(20, 20, 20);
  doc.text(j.service, 18, y);
  const amount = j.price ? `£${j.price}.00` : 'Quote'; doc.text(amount, 170, y); y += 10;
  doc.setDrawColor(220, 224, 230); doc.line(14, y, 196, y); y += 10;
  doc.setFont('helvetica', 'bold'); doc.text('Total', 18, y); doc.text(amount, 170, y);
  doc.save(`INV-${j.id}.pdf`);
};
